<template>
  <footer id="footer" role="contentinfo">
    <a href="#" class="gotop js-gotop"><i class="icon-arrow-up2"></i></a>
    <div class="container">
      <div class="">
        <div class="col-md-12 text-center">
          <p>&copy; EB Solutions. Todos os direitos reservados.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <ul class="social social-circle">
            <li><a target="_blank" href="https://twitter.com/EbsCloud"><i class="icon-twitter"></i></a></li>
            <li><a target="_blank" href="https://www.facebook.com/ebscloud"><i class="icon-facebook"></i></a></li>
            <li><a target="_blank" href="https://www.linkedin.com/company/ebscloud"><i class="icon-linkedin"></i></a></li>
            <li><a target="_blank" href="https://www.instagram.com/ebscloud/"><i class="icon-instagram"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
